import e, { createContext as be, useContext as fe, forwardRef as Z, useRef as S, useCallback as A, useMemo as le, useEffect as O, useSyncExternalStore as ie, useState as B, useId as Y, useDeferredValue as pe } from "react";
import { c as x, t as E, D as ye } from "./app-a75c1d35.mjs";
import { PageHeader as je } from "./PageHeader.js";
import { D as ae } from "./Dropdown-cd8b285a.mjs";
import { m as Q, a as D } from "./index-615eb227.mjs";
import { I as J, W as N } from "./Icon-3122c134.mjs";
import { b as Le } from "./useClickOutside-726e7c36.mjs";
import { B as R } from "./Block-9b78bd10.mjs";
import { B as ne } from "./Button-c598cb52.mjs";
const ce = be(void 0);
function C() {
  const t = fe(ce);
  if (!t)
    throw new Error(
      "TypeAheadRefsContext should be only used inside TypeAhead component."
    );
  return t;
}
function ee(t) {
  const o = "type-ahead";
  return (...a) => ({
    id: [o, t, ...a].join("-"),
    "data-testid": [o, ...a].join("-")
  });
}
function oe(t) {
  return t?.querySelectorAll("[tabindex]");
}
function I(t) {
  return typeof t == "string" ? {
    label: t,
    value: t
  } : {
    value: t.value,
    label: t.label || t.value
  };
}
const xe = "visually-hidden", ve = "type-ahead", Ee = "type-ahead__input", Fe = "type-ahead__input--expanded", ge = "type-ahead__input--input-field", Ie = "type-ahead__input--clear-button", Ae = "type-ahead__list-box", Ce = "type-ahead__list-box-item", He = "type-ahead__list-box-item--heading", Be = "type-ahead__list-box-item--action", we = "type-ahead__list-box-item--action-type", _e = "type-ahead__list-box-loading", v = {
  visuallyHidden: xe,
  typeAhead: ve,
  typeAheadInput: Ee,
  typeAheadInputExpanded: Fe,
  typeAheadInputInputField: ge,
  typeAheadInputClearButton: Ie,
  typeAheadListBox: Ae,
  typeAheadListBoxItem: Ce,
  typeAheadListBoxItemHeading: He,
  typeAheadListBoxItemAction: Be,
  typeAheadListBoxItemActionType: we,
  typeAheadListBoxLoading: _e
};
function Te(t, o) {
  const { className: a, onChange: r, onClear: s, ...l } = t, { isListBoxOpen: i } = C(), { uuid: c } = C(), n = S(null), h = t.value.length > 0, d = ee(c), u = d("input"), p = A(
    (m) => r(m.currentTarget.value),
    [r]
  ), y = A(() => {
    h && (r(""), s?.()), n.current?.focus();
  }, [h, r, s]);
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      ...d("input-container"),
      className: x(
        v.typeAheadInput,
        i && v.typeAheadInputExpanded
      )
    },
    /* @__PURE__ */ e.createElement(
      "input",
      {
        ...u,
        ...l,
        id: l.id || u.id,
        ref: Q(o, n),
        className: x(
          a,
          v.typeAheadInputInputField,
          E.textsLeadText
        ),
        onChange: p,
        role: "combobox",
        autoComplete: "off",
        "aria-expanded": i,
        "aria-haspopup": "listbox",
        "aria-autocomplete": "list",
        "aria-controls": d("list").id
      }
    ),
    /* @__PURE__ */ e.createElement(
      "button",
      {
        ...d("input-icon-button"),
        className: v.typeAheadInputClearButton,
        "aria-label": h ? "Search Close" : "Search",
        onClick: y
      },
      /* @__PURE__ */ e.createElement(J, { icon: h ? N.CLOSE : N.SEARCH, size: 20 })
    )
  );
}
const Se = Z(Te);
function Ne(t, o) {
  const a = ee(t.uuid);
  if (t.variant === "heading")
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        ...a("list-item", t.variant),
        ref: o,
        className: x(
          v.typeAheadListBoxItem,
          v.typeAheadListBoxItemHeading
        ),
        disabled: !0
      },
      /* @__PURE__ */ e.createElement("span", { className: E.textsLeadText }, t.value)
    );
  const { label: r } = I(t.option);
  return t.variant === "action" && t.prefixText === "" ? /* @__PURE__ */ e.createElement(e.Fragment, null) : /* @__PURE__ */ e.createElement(
    "button",
    {
      ...a("list-item", t.variant),
      ref: o,
      className: x(
        v.typeAheadListBoxItem,
        t.variant === "action" && v.typeAheadListBoxItemAction
      ),
      onClick: () => t.onClick(t.option),
      tabIndex: -1,
      role: "option"
    },
    /* @__PURE__ */ e.createElement(
      J,
      {
        icon: t.variant === "history" ? N.CLOCK : N.SEARCH,
        size: 16
      }
    ),
    t.variant === "action" ? /* @__PURE__ */ e.createElement("div", { className: E.textsLeadTextBold }, t.prefixText, " ", `"${r}"`) : t.variant === "autocomplete" ? /* @__PURE__ */ e.createElement(Oe, { ...t }) : /* @__PURE__ */ e.createElement("div", { className: E.textsLeadText }, r)
  );
}
const k = Z(Ne);
function Oe({
  option: t,
  latestWord: o,
  isFirstWord: a
}) {
  const { label: r } = I(t), { type: s } = t, { isNewJobsHeader: l } = C(), i = l ? r : o ? r.toLowerCase().split(o.trim().toLowerCase()).slice(1) : r;
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: E.textsLeadText }, a ? "" : "...", typeof i == "string" ? /* @__PURE__ */ e.createElement("span", null, i) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("strong", null, o), /* @__PURE__ */ e.createElement("span", null, i.join("")))), s ? /* @__PURE__ */ e.createElement(
    "div",
    {
      className: x(
        E.textsCaption,
        v.typeAheadListBoxItemActionType
      )
    },
    "•  ",
    s
  ) : null);
}
function We({
  i18n: t,
  autocompleteSuggestions: o,
  changeSearchValue: a
}) {
  const {
    firstListBoxItemRef: r,
    lastListBoxItemRef: s,
    searchValue: l,
    currentWord: i,
    uuid: c,
    isNewJobsHeader: n
  } = C(), h = A(
    (m) => {
      const { value: b } = I(m);
      if (n)
        a(b + " ", !1);
      else {
        const j = l.split(" ").map((L) => L === i ? b : L).join(" ");
        a(j + " ", !1);
      }
    },
    [a, l, i, n]
  ), d = A(
    (m) => {
      const { value: b } = I(m);
      a(b, !0);
    },
    [a]
  ), u = le(() => {
    if (n)
      return o;
    const m = i.trim().toLowerCase();
    return m ? o.filter((b) => {
      const { value: j } = I(b);
      return j.trim().toLowerCase().startsWith(m);
    }) : [];
  }, [o, i, n]), { isLoading: p } = C(), y = n ? "No results found. Please use another job title." : "No results found";
  return /* @__PURE__ */ e.createElement(e.Fragment, null, p ? /* @__PURE__ */ e.createElement(
    "span",
    {
      className: x(
        E.textsLeadText,
        v.typeAheadListBoxLoading
      )
    },
    "Loading…"
  ) : u.length ? u.map((m, b) => {
    const { value: j } = I(m), { type: L } = m, H = n ? !0 : l.split(" ").length === 1;
    return /* @__PURE__ */ e.createElement(
      k,
      {
        key: j + L,
        uuid: c + b,
        variant: "autocomplete",
        option: m,
        latestWord: i,
        isFirstWord: H,
        onClick: h,
        ref: b === 0 ? r : void 0
      }
    );
  }) : /* @__PURE__ */ e.createElement(
    "span",
    {
      className: x(
        E.textsLeadText,
        v.typeAheadListBoxLoading
      )
    },
    y
  ), /* @__PURE__ */ e.createElement(
    k,
    {
      uuid: c,
      variant: "action",
      option: l,
      prefixText: n ? "" : t?.searchFor || "Search for",
      onClick: d,
      ref: Q(
        s,
        o.length === 0 ? r : void 0
      )
    }
  ));
}
function Re({
  searchHistory: t = [],
  i18n: o,
  onClick: a
}) {
  const { firstListBoxItemRef: r, lastListBoxItemRef: s, uuid: l } = C();
  return t.length === 0 ? null : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    k,
    {
      uuid: l,
      variant: "heading",
      value: o?.searchHistory || "Search history"
    }
  ), t.slice(0, 2).map((i, c) => {
    const { value: n } = I(i);
    return /* @__PURE__ */ e.createElement(
      k,
      {
        uuid: l + c,
        key: n,
        option: i,
        variant: "history",
        onClick: a,
        ref: Q(
          c === 0 ? r : void 0,
          s
        )
      }
    );
  }));
}
function ke({
  searchRecommendations: t,
  i18n: o,
  onClick: a,
  isSearchHistoryEmpty: r
}) {
  const { firstListBoxItemRef: s, lastListBoxItemRef: l, uuid: i } = C();
  return t.length === 0 ? null : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    k,
    {
      uuid: i,
      variant: "heading",
      value: o?.searchRecommendations || "Give these searches a try"
    }
  ), t.slice(0, 5).map((c, n) => {
    const { value: h } = I(c);
    return /* @__PURE__ */ e.createElement(
      k,
      {
        uuid: i + n,
        key: h,
        option: c,
        variant: "recommendation",
        onClick: a,
        ref: Q(
          r && n === 0 ? s : void 0,
          l
        )
      }
    );
  }));
}
const Me = [
  " ",
  // space
  "Backspace".toLowerCase(),
  ..."abcdefghijklmnopqrstuvwxyzäö0123456789".split("")
];
function De() {
  const t = S(-1), o = S(!1), {
    listBoxRef: a,
    searchRef: r,
    firstListBoxItemRef: s,
    lastListBoxItemRef: l,
    searchValue: i
  } = C();
  O(() => {
    t.current = -1;
  }, [i]);
  const c = ie(
    Pe,
    $e,
    () => null
  );
  return O(() => {
    if (c === s.current && (t.current = 0), c === l.current) {
      const n = oe(a.current), h = Math.max(n?.length || 0, 0);
      t.current = h - 1;
    }
  }, [c, s, l, a]), A(
    (n) => {
      const h = oe(a.current), d = h?.length || 0, u = t.current;
      if (d === 0)
        return;
      if (Me.includes(n.key.toLowerCase()))
        return r.current?.focus();
      const p = (L) => {
        o.current = !0, t.current = Math.min(Math.max(0, L), d - 1), h?.item(t.current)?.focus();
      }, y = () => p(0), m = () => p(d - 1), b = () => p((u + 1) % d), j = () => p(u <= 0 ? d - 1 : u - 1);
      switch (n.key) {
        case "Tab":
          return n.preventDefault(), n.shiftKey ? u === 0 ? r.current?.focus() : j() : b();
        case "ArrowDown":
          return n.preventDefault(), n.metaKey ? m() : b();
        case "ArrowUp":
          return n.preventDefault(), n.metaKey ? y() : j();
      }
    },
    [a, r]
  );
}
function Pe(t) {
  return window.addEventListener("focusin", t), () => window.removeEventListener("focusin", t);
}
function $e() {
  return window.document.activeElement;
}
function ze({
  isOpen: t,
  searchHistory: o,
  searchRecommendations: a,
  searchAutocompleteSuggestion: r,
  i18n: s,
  changeSearchValue: l,
  onSearchRecommendationClick: i,
  closeListBox: c
}, n) {
  const { uuid: h, searchValue: d, isNewJobsHeader: u } = C(), p = d.trim().length === 0, y = ee(h), m = De(), b = A(
    (L) => l(L, !0),
    [l]
  ), j = A(
    (L) => {
      i ? (c(), i(L)) : b(L);
    },
    [c, b, i]
  );
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      ...y("list"),
      ref: n,
      className: v.typeAheadListBox,
      role: "listbox",
      "data-open": t,
      onKeyDown: m,
      tabIndex: 0
    },
    p ? /* @__PURE__ */ e.createElement(e.Fragment, null, !u && /* @__PURE__ */ e.createElement(
      Re,
      {
        searchHistory: o,
        i18n: s,
        onClick: b
      }
    ), /* @__PURE__ */ e.createElement(
      ke,
      {
        searchRecommendations: a,
        i18n: s,
        isSearchHistoryEmpty: o.length === 0,
        onClick: j
      }
    )) : /* @__PURE__ */ e.createElement(
      We,
      {
        i18n: s,
        changeSearchValue: l,
        autocompleteSuggestions: r
      }
    )
  );
}
const Ke = Z(ze);
function Ve(t, o, a) {
  const [r, s] = B(!1), l = A(() => {
    s(!0), a?.(!0);
  }, [a]), i = A(() => {
    s(!1), a?.(!1);
  }, [a]);
  return Le([o, t], i, {
    disabled: !r
  }), { isListBoxOpen: r, openListBox: l, closeListBox: i };
}
function de({
  defaultValue: t = "",
  searchHistory: o = [],
  searchRecommendations: a = [],
  searchAutocompleteSuggestion: r = [],
  placeholder: s,
  i18n: l,
  onSearch: i,
  onSearchListBoxOpenChange: c,
  onSearchRecommendationClick: n,
  onClear: h,
  onCurrentWordChange: d,
  isNewJobsHeader: u,
  isLoading: p,
  inputId: y,
  labelId: m
}) {
  const b = Y(), j = y || `${b}-search`, L = l?.searchLabel || "Search jobs", H = S(null), W = S(null), $ = S(null), z = S(null), [g, K] = B(t), { isListBoxOpen: M, openListBox: w, closeListBox: _ } = Ve(
    W,
    H,
    c
  );
  O(() => {
    K(t);
  }, [t]);
  const T = D((F) => {
    i(F), _(), H.current?.blur();
  }), V = D(() => {
    (!g || !g.endsWith(" ")) && w();
  }), U = D(() => {
    g || w();
  }), q = D(
    (F, he = !1) => {
      const { label: te, value: se } = I(F);
      K(te), te.endsWith(" ") ? (_(), T(se)) : w(), he ? T(se) : H.current?.focus();
    }
  ), G = D(
    (F) => {
      switch (F.key) {
        case "Enter":
          return T(F.currentTarget.value);
        case "ArrowDown":
          return F.preventDefault(), w(), $.current?.focus();
        case "ArrowUp":
          return F.preventDefault(), w(), z.current?.focus();
      }
    }
  ), me = le(() => {
    if (u)
      return g;
    const F = g.split(" ");
    return F[F.length - 1]?.trim();
  }, [g, u]), X = pe(me);
  return O(() => {
    d?.(X);
  }, [X, d]), /* @__PURE__ */ e.createElement(
    ce.Provider,
    {
      value: {
        searchRef: H,
        listBoxRef: W,
        firstListBoxItemRef: $,
        lastListBoxItemRef: z,
        searchValue: g,
        isListBoxOpen: M,
        currentWord: X,
        uuid: b,
        isNewJobsHeader: u,
        isLoading: p
      }
    },
    /* @__PURE__ */ e.createElement("div", { "data-testid": "type-ahead", className: v.typeAhead }, m ? null : /* @__PURE__ */ e.createElement("label", { htmlFor: j, className: v.visuallyHidden }, L), /* @__PURE__ */ e.createElement(
      Se,
      {
        ref: H,
        id: j,
        "aria-labelledby": m,
        name: "jobs-search",
        value: g,
        placeholder: s || (u ? "Job title" : "Job title, company or location"),
        className: x(v.typeAheadInput, E.textsLeadText),
        onChange: q,
        onKeyDown: G,
        onClick: V,
        onFocus: U,
        onClear: h
      }
    ), /* @__PURE__ */ e.createElement(
      Ke,
      {
        ref: W,
        isOpen: M,
        searchHistory: o,
        searchRecommendations: u ? [] : a,
        searchAutocompleteSuggestion: r,
        i18n: l,
        changeSearchValue: q,
        onSearchRecommendationClick: n,
        closeListBox: _
      }
    ))
  );
}
const Ue = "jobs-header", qe = "jobs-header__content", Ge = "desktop", Je = "jobs-header--with-filters", Qe = "jobs-header__with-filters-top", Xe = "jobs-header__with-filters-copy", Ye = "jobs-header__with-filters-heading", Ze = "jobs-header__with-filters-lead", et = "jobs-header__with-filters-toggle", tt = "jobs-header__with-filters-row", st = "jobs-filters-field", at = "jobs-header__reset", nt = "jobs-header__mobile-overlay", ot = "jobs-filters-field-label", rt = "jobs-header__mobile-overlay-header", lt = "jobs-header__mobile-overlay-title", it = "jobs-header__mobile-close", ct = "jobs-header__mobile-close-icon", dt = "jobs-header__mobile-overlay-body", f = {
  jobsHeader: Ue,
  jobsHeaderContent: qe,
  desktop: Ge,
  jobsHeaderWithFilters: Je,
  jobsHeaderWithFiltersTop: Qe,
  jobsHeaderWithFiltersCopy: Xe,
  jobsHeaderWithFiltersHeading: Ye,
  jobsHeaderWithFiltersLead: Ze,
  jobsHeaderWithFiltersToggle: et,
  jobsHeaderWithFiltersRow: tt,
  jobsFiltersField: st,
  jobsHeaderReset: at,
  jobsHeaderMobileOverlay: nt,
  jobsFiltersFieldLabel: ot,
  jobsHeaderMobileOverlayHeader: rt,
  jobsHeaderMobileOverlayTitle: lt,
  jobsHeaderMobileClose: it,
  jobsHeaderMobileCloseIcon: ct,
  jobsHeaderMobileOverlayBody: dt
}, ut = "jobs-filters", mt = "jobs-filters--singleton", ht = "jobs-filters__hidden-field", bt = "jobs-filters--with-filters", P = {
  jobsFilters: ut,
  jobsFiltersSingleton: mt,
  jobsFiltersHiddenField: ht,
  jobsFiltersWithFilters: bt
};
function re(t) {
  return t.reduce((o, a) => o + (a.count ?? 0), 0);
}
function ue({
  categories: t,
  cities: o,
  i18n: a,
  onFilterOpenChange: r,
  isNewJobsHeader: s,
  isDisabled: l,
  layout: i = "default"
}) {
  const c = i === "with-filters", [n, h] = B(!1), [d, u] = B(!1);
  if (O(
    () => r?.(n || d),
    [r, n, d]
  ), !(t.items.length > 0 || o.items.length > 0))
    return null;
  const y = a.category || (s ? "Function" : "Category"), m = a.city || (s ? "Location" : "City");
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "jobs-filters",
      className: x(
        P.jobsFilters,
        c && P.jobsFiltersWithFilters,
        !c && (n || d) && P.jobsFiltersSingleton
      )
    },
    t.items.length > 0 && /* @__PURE__ */ e.createElement(
      ae,
      {
        "data-testid": "jobs-filter-categories",
        label: c ? `${y} (${re(t.items)})` : y,
        className: x(
          !c && d && P.jobsFiltersHiddenField
        ),
        onOpenStateChange: h,
        ...t,
        ...s ? { disabled: l } : {}
      }
    ),
    o.items.length > 0 && /* @__PURE__ */ e.createElement(
      ae,
      {
        "data-testid": "jobs-filter-cities",
        label: c ? `${m} (${re(o.items)})` : m,
        className: x(
          !c && n && P.jobsFiltersHiddenField
        ),
        onOpenStateChange: u,
        ...o,
        emptyMessage: s ? "No locations found" : void 0,
        showFilterInput: !0,
        ...s ? { disabled: l } : {}
      }
    )
  );
}
function ft(t) {
  return window.addEventListener("resize", t), () => window.removeEventListener("resize", t);
}
function pt({
  id: t,
  heading: o,
  leadText: a,
  onDropdownOpenChange: r,
  i18n: s = {},
  search: l,
  categories: i,
  cities: c,
  isNewJobsHeader: n,
  isLoading: h
}) {
  const [d, u] = B(!1), [p, y] = B(!1);
  return O(
    () => r?.(d || p),
    [r, d, p]
  ), /* @__PURE__ */ e.createElement(
    je,
    {
      id: t,
      heading: o,
      leadText: a,
      bottomPadding: R.Padding.NONE,
      "data-testid": "jobs-header",
      backgroundColor: "blue",
      className: f.jobsHeader
    },
    /* @__PURE__ */ e.createElement("div", { className: f.jobsHeaderContent }, /* @__PURE__ */ e.createElement(
      de,
      {
        ...l,
        onSearchListBoxOpenChange: u,
        i18n: s,
        isNewJobsHeader: n,
        isLoading: h
      }
    ), /* @__PURE__ */ e.createElement(
      ue,
      {
        categories: i,
        cities: c,
        onFilterOpenChange: y,
        i18n: s,
        isNewJobsHeader: n,
        isDisabled: l?.searchAutocompleteSuggestion?.length === 0
      }
    ))
  );
}
function yt({
  id: t,
  heading: o,
  leadText: a,
  onDropdownOpenChange: r,
  i18n: s = {},
  search: l,
  categories: i,
  cities: c,
  isNewJobsHeader: n,
  isLoading: h,
  filtersVisible: d = !0,
  onToggleFilters: u,
  onResetFilters: p,
  totalJobs: y = 0
}) {
  const [m, b] = B(!1), [j, L] = B(!1), W = ie(
    ft,
    () => window.innerWidth,
    () => 0
  ) < ye.md;
  O(
    () => r?.(m || j),
    [r, m, j]
  );
  const $ = s.showFilters || "Show filters", z = s.hideFilters || "Hide filters", g = s.resetFilters || "Reset filters", K = s.showJobs || `Show jobs (${y})`, M = s.filtersTitle || "Filters", w = s.close || "Close", _ = Y(), T = Y(), V = /* @__PURE__ */ e.createElement(
    de,
    {
      ...l,
      inputId: _,
      labelId: s.searchLabel ? T : void 0,
      onSearchListBoxOpenChange: b,
      i18n: s,
      isNewJobsHeader: n,
      isLoading: h
    }
  ), U = /* @__PURE__ */ e.createElement(
    ue,
    {
      categories: i,
      cities: c,
      onFilterOpenChange: L,
      i18n: s,
      isNewJobsHeader: n,
      isDisabled: l?.searchAutocompleteSuggestion?.length === 0,
      layout: "with-filters"
    }
  ), q = /* @__PURE__ */ e.createElement(
    ne.Secondary,
    {
      text: d ? z : $,
      icon: N.FILTER,
      iconPosition: "left",
      onClick: u,
      "data-testid": "jobs-header-toggle-filters"
    }
  ), G = /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: f.jobsHeaderReset,
      onClick: p,
      "data-testid": "jobs-header-reset-filters"
    },
    /* @__PURE__ */ e.createElement(J, { icon: N.CLOSE, size: 16 }),
    g
  );
  return /* @__PURE__ */ e.createElement(
    R,
    {
      id: t,
      "data-testid": "jobs-header",
      "data-layout": "with-filters",
      topPadding: R.Padding.SMALL,
      bottomPadding: R.Padding.NONE,
      className: x(f.jobsHeader, f.jobsHeaderWithFilters)
    },
    /* @__PURE__ */ e.createElement(R.Content, null, /* @__PURE__ */ e.createElement("div", { className: f.jobsHeaderWithFiltersTop }, /* @__PURE__ */ e.createElement("div", { className: f.jobsHeaderWithFiltersCopy }, /* @__PURE__ */ e.createElement(
      "h2",
      {
        className: x(
          E.pageHeading,
          f.jobsHeaderWithFiltersHeading
        )
      },
      o
    ), a && /* @__PURE__ */ e.createElement(
      "p",
      {
        className: x(
          E.textsComponentTitle,
          f.jobsHeaderWithFiltersLead
        )
      },
      a
    )), /* @__PURE__ */ e.createElement("div", { className: f.jobsHeaderWithFiltersToggle }, q))),
    d && !W && /* @__PURE__ */ e.createElement(R.Content, null, /* @__PURE__ */ e.createElement(
      "div",
      {
        className: f.jobsHeaderWithFiltersRow,
        "data-testid": "jobs-header-filters"
      },
      /* @__PURE__ */ e.createElement("div", { className: f.jobsFiltersField }, s.searchLabel && /* @__PURE__ */ e.createElement(
        "label",
        {
          id: T,
          htmlFor: _,
          className: f.jobsFiltersFieldLabel
        },
        s.searchLabel
      ), V),
      U,
      G
    )),
    d && W && /* @__PURE__ */ e.createElement(
      "div",
      {
        className: f.jobsHeaderMobileOverlay,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": M,
        "data-testid": "jobs-header-mobile-filters"
      },
      /* @__PURE__ */ e.createElement("div", { className: f.jobsHeaderMobileOverlayHeader }, /* @__PURE__ */ e.createElement(
        "h2",
        {
          className: x(
            E.textsComponentTitle,
            f.jobsHeaderMobileOverlayTitle
          )
        },
        M
      ), /* @__PURE__ */ e.createElement(
        "button",
        {
          type: "button",
          className: f.jobsHeaderMobileClose,
          onClick: u
        },
        w,
        /* @__PURE__ */ e.createElement("span", { className: f.jobsHeaderMobileCloseIcon }, /* @__PURE__ */ e.createElement(J, { icon: N.CLOSE, size: 20 }))
      )),
      /* @__PURE__ */ e.createElement("div", { className: f.jobsHeaderMobileOverlayBody }, /* @__PURE__ */ e.createElement("div", { className: f.jobsFiltersField }, s.searchLabel && /* @__PURE__ */ e.createElement(
        "label",
        {
          id: T,
          htmlFor: _,
          className: f.jobsFiltersFieldLabel
        },
        s.searchLabel
      ), V), U, /* @__PURE__ */ e.createElement(
        ne.Primary,
        {
          text: K,
          onClick: u,
          "data-testid": "jobs-header-show-jobs"
        }
      )),
      G
    )
  );
}
function Ct(t) {
  return t.layout === "with-filters" ? /* @__PURE__ */ e.createElement(yt, { ...t }) : /* @__PURE__ */ e.createElement(pt, { ...t });
}
export {
  Ct as JobsHeader
};
//# sourceMappingURL=JobsHeader.js.map
